import React, { useEffect, useState } from "react";
import { useNavigate,useParams } from "react-router-dom";
import productIcon from '../../../assets/icons//products.svg';
import GetRequest from "../../../service/GetRequest";
import ProfileIntiationLablesContainer from "../../../components/DashboardComponents/ProfileIntiationLablesContainer";
import { Button } from 'primereact/button';
import GridViewProductItemCard from "../../../components/Widgets/Cards/GridViewProductItemCard";

const BranchProductsListPage = ({setActivePath}) => {
    const navigate = useNavigate();
    const { branchId } = useParams();
    const [products,setProducts] = useState([]); // Assuming 'data' is the parameter name

    
    useEffect(() => {
        setActivePath("Dashboard");
        GetRequest(`v1/inventory-service/view/branches/${branchId}/items`,true)
            .then(response => {
                if (!response || response === undefined) {
                    console.log("No Branch found");
                } else {
                    console.log(response);
                    setProducts(response);
                }
            })
            .catch(error => {
                console.error("Error fetching store data:", error);
            });
            
      }, [setActivePath,branchId]);

      const continueAction = () => {
        navigate("/store/complete/profile");  
    }
    

  return (
    <div className="outlet-container">
              <div className="background-white">
                <div className="background-white-sub-container">
                <br/>
                    <ProfileIntiationLablesContainer title="View Products" description="View Products" status={true} icon={productIcon} iconBackgroundColor="#CE7B69" navigation={"/store/branch/add/product/"+branchId} isActionRequired actionName="Add product"/>
                    <br/>
                    <div className="products-grid">
                        {products.map(product => (
                            <GridViewProductItemCard name={product.name} productCategory={product.category} itemId={product.itemId} sellingPrice={product.sellingPrice} productImage={product.productImage}/>
                        ))}
                    </div>
                    <Button onClick={continueAction} variant="contained" label="Save and Continue"/>

    </div></div></div>
  )
}

export default BranchProductsListPage
